import { createSelector } from 'reselect'
import blockerType from 'const/blockerType'

const getAllBlockerIds = (state) => {
  return state.kanbo.blockers.ids
}

const getBlockersById = (state) => {
  return state.kanbo.blockers.byId
}

const createSortedBlockersSelector = (getBoardBlockerIds) => createSelector(
  [
    getBoardBlockerIds,
    getAllBlockerIds,
    getBlockersById,
  ],
  (
    boardBlockerIds: any[],
    allBlockerIds,
    blockersById,
  ) =>
    [
      ...boardBlockerIds.map(id => blockersById[id]),
      ...allBlockerIds.filter(id => blockersById[id].type === blockerType.GLOBAL).map(id => blockersById[id]),
    ].sort((a, b) => a.position - b.position)
)

export default createSortedBlockersSelector
